import { useEffect } from 'react'
import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import { useT } from '../i18n/useT'

const TOUR_KEY = 'mindesk-tour-done'

export function isTourDone() {
  return !!localStorage.getItem(TOUR_KEY)
}

export default function OnboardingTour() {
  const t = useT()

  useEffect(() => {
    if (isTourDone()) return

    const timer = setTimeout(() => {
      const allSteps = [
        { element: '#tour-smartbar',      popover: { title: t('tour_smartbar_title'),      description: t('tour_smartbar_desc'),      side: 'bottom' } },
        { element: '#tour-fab',           popover: { title: t('tour_fab_title'),           description: t('tour_fab_desc'),           side: 'top'    } },
        { element: '#tour-sidebar-add',   popover: { title: t('tour_sidebar_add_title'),   description: t('tour_sidebar_add_desc'),   side: 'right'  } },
        { element: '#tour-task',          popover: { title: t('tour_task_title'),          description: t('tour_task_desc'),          side: 'bottom' } },
        { element: '#tour-agent',         popover: { title: t('tour_agent_title'),         description: t('tour_agent_desc'),         side: 'top'    } },
        { element: '#tour-sidebar-agent', popover: { title: t('tour_agent_title'),         description: t('tour_agent_desc'),         side: 'right'  } },
        { element: '#tour-nav',           popover: { title: t('tour_nav_title'),           description: t('tour_nav_desc'),           side: 'top'    } },
        { element: '#tour-sidebar-nav',   popover: { title: t('tour_sidebar_nav_title'),   description: t('tour_sidebar_nav_desc'),   side: 'right'  } },
        { element: '#tour-settings',      popover: { title: t('tour_settings_title'),      description: t('tour_settings_desc'),      side: 'bottom' } },
      ]

      const availableSteps = allSteps.filter(s => {
        const el = document.querySelector(s.element)
        if (!el) return false
        const rect = el.getBoundingClientRect()
        return rect.width > 0 && rect.height > 0
      })
      if (!availableSteps.length) return

      const d = driver({
        showProgress: true,
        animate: true,
        overlayColor: 'rgba(0, 0, 0, 0.7)',
        stagePadding: 8,
        stageRadius: 12,
        allowClose: false,
        overlayClickNext: false,
        popoverClass: 'mindesk-tour-popover',
        nextBtnText: t('tour_next'),
        prevBtnText: t('tour_prev'),
        doneBtnText: t('tour_done'),
        steps: availableSteps,
        onDestroyed: () => {
          localStorage.setItem(TOUR_KEY, '1')
          window.dispatchEvent(new Event('tour-complete'))
        },
      })

      d.drive()
    }, 800)

    return () => clearTimeout(timer)
  }, []) // eslint-disable-line

  return null
}
